//============================================================================
// Name        : rfids.ts
// Purpose     : Implement rfids base dynamics
// Created     : 2020-02-20
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

import {InitPage} from "../index";

class Rfid {
    init() {
        $("select").select2({
            minimumResultsForSearch: 5
        });
    }
}

export function LoadPage() {
    InitPage("rfids", () => {
        const rfid = new Rfid();
        rfid.init();
    });
    InitPage("transfer_slips", () => {
        const rfid = new Rfid();
        rfid.init();
    });
}
